<div *ngIf="state$ | async as s" class="container-fluid">
  <!-- HEADER -->
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h4 class="page-title mb-0">Ders Başlat ve Yoklama Ayarları</h4>

    <div class="step-indicator">
      <div class="step" [class.active]="s.ui.currentStep === 1">1</div>
      <div class="step" [class.active]="s.ui.currentStep === 2">2</div>
    </div>

    <div>
      <button class="btn btn-danger btn-sm ms-2" (click)="geri()">Geri</button>
    </div>
  </div>

  <!-- STEP 1 / START SCREEN -->
  <div [class.active]="s.ui.currentStep !== 1" class="yoklama-container">


    <div class="course-info mb-3">
      <div>
        <strong>Ders Adı:</strong>
        {{ s.course.dersAd }}
      </div>

      <div>
        <strong>Ders Kodu:</strong>
        {{ s.course.acilanDersNo }}
      </div>

      <div>
        <strong>Derslik:</strong>
        {{ s.course.dersAdres?? "Derslik bilgisi yok" }}
      </div>


    </div>

    <div class="toggles-row">
      <mat-slide-toggle [checked]="s.ui.qrUret" (change)="facade.setUi({ qrUret: $event.checked })">
        QR Üret
      </mat-slide-toggle>

      <mat-slide-toggle [checked]="s.ui.konumKontrol" (change)="facade.setUi({ konumKontrol: $event.checked })">
        Konum Kontrolü
      </mat-slide-toggle>
    </div>

    <div class="yoklama-info" *ngIf="s.ui.currentStep === 1">
      Derslik durumuna göre yoklama kriterlerini seçiniz.
    </div>

    <div class="yoklama-buttons" *ngIf="s.ui.currentStep === 1">
      <button class="btn btn-success" (click)="facade.startYoklama()">
        Yoklamayı Başlat
      </button>
    </div>
  </div>

  <!-- STEP 2 / DASHBOARD -->
  <div class="row" *ngIf="s.ui.currentStep === 2">
    <!-- LEFT PANEL -->
    <div class="col-12 col-lg-4 mb-3">
      <div class="card p-3 info-card">
        <!-- TIMER -->
        <div class="timer-display">
          <div class="time-large">
            {{ s.ui.kalanSure }}
          </div>
          <div class="muted small">Kalan süre</div>
        </div>

        <hr />
        {{s.course.dersBaslangic | date: "dd-MM-yyyy"}} - {{s.course.dersBitis | date: "dd-MM-yyyy" }}

        <!-- YOKLAMA SÜRESİ -->
        <label class="form-label">Yoklama Süresi (dk)</label>
        <select class="form-select" [ngModel]="s.attendance.attendanceDuration"
          (ngModelChange)="facade.setAttendance({ attendanceDuration: $event })">
          <option *ngFor="let opt of [1, 2, 3, 4, 5, 10, 15]" [ngValue]="opt">
            {{ opt }} dakika
          </option>
        </select>

        <hr />

        <!-- PERİYOT -->
        <mat-radio-group [value]="s.attendance.yoklamaPeriyodu"
          (change)="facade.setAttendance({ yoklamaPeriyodu: $event.value })" class="d-flex flex-column gap-2">
          <mat-radio-button value="saatbasi"
            [disabled]="s.ui.coursePhase !== 'idle' && s.attendance.yoklamaPeriyodu === 'teksefer'">
            Saat Başı
          </mat-radio-button>

          <mat-radio-button value="teksefer"
            [disabled]="s.ui.coursePhase !== 'idle' && s.attendance.yoklamaPeriyodu === 'saatbasi'">
            Tek Seferde Al
          </mat-radio-button>
        </mat-radio-group>

        <hr />

        <!-- SLOT -->
        <div>
          <h6>Ders Saatleri</h6>

          <div class="d-flex flex-column gap-2">
            <mat-checkbox *ngFor="let slot of s.attendance.slots; let i = index" [checked]="slot.active"
              (change)="facade.setSlotActive(i, $event.checked)"
              [checked]="s.attendance.yoklamaPeriyodu === 'teksefer' ? true : slot.active || s.ui.coursePhase === 'ended' ? true : false"
              [disabled]="s.attendance.yoklamaPeriyodu === 'teksefer'|| s.attendance.aktifSlotIndex > i || s.ui.coursePhase === 'ended'">
              {{ i + 1 }}. Saat — {{ slot.label }}
            </mat-checkbox>
          </div>
        </div>
        <!-- START / UPDATE -->
        <div class="d-grid gap-2">

          <!-- 🟡 DERS BAŞLAT (idle) -->
          <button class="btn btn-primary" *ngIf="s.ui?.coursePhase === 'idle'" (click)="facade.startCourse()">
            Dersi Başlat
          </button>


          <!-- 🟢 DEVAM (running) -->
          <button class="btn btn-warning" *ngIf="s.ui?.coursePhase === 'running'" (click)="facade.updateCourse()">
            Yoklamayı Devam Ettir
          </button>

          <!-- 🔴 BİTMİŞ -->
          <button class="btn btn-success" *ngIf="s.ui?.coursePhase === 'ended'" (click)="facade.obsAktar()">
            OBS'ye Yoklama Aktar
          </button>
        </div>

        <hr />
      </div>
    </div>

    <!-- QR / MAP -->
    <div class="col-12 col-lg-3 mb-3" *ngIf="s.ui.qrUret || s.ui.konumKontrol">
      <div class="card p-3 info-card text-center">
        <div *ngIf="s.ui.qrUret">
          <img *ngIf="s.ui.qrBase64" [src]="s.ui.qrBase64" style="max-width: 100%; border-radius: 8px" />

          <div *ngIf="!s.ui.qrBase64" class="qr-placeholder">
            QR kodu Ders başlatınca görebilirsiniz.
          </div>
        </div>

        <div *ngIf="(state$ | async)?.ui?.konumKontrol" class="mt-3">

          <div #mapContainer style="height: 300px"></div>



          <div *ngIf="mapMessage" class="map-message">
            {{ mapMessage }}
           </div>
        </div>
      </div>
    </div>

    <!-- STUDENT LIST -->
    <div class="col-12 col-lg-5 mb-3">
      <div class="card p-3 info-card">
        <input type="text" class="form-control mb-2" placeholder="Ara" [ngModel]="s.ui.search"
          (ngModelChange)="facade.setUi({ search: $event })" />
        <!-- SAAT BAŞI -->
        <ng-container *ngIf="facade.state.getState().attendance.yoklamaPeriyodu=='saatbasi' ">
          <ul class="nav nav-tabs mb-2">
            <li class="nav-item" *ngFor="let slot of s.attendance.slots; let i = index">
              <a class="nav-link" (click)="benimMesaj()" [class.active]="s.attendance.aktifSlotIndex === i">
                {{ i + 1 }}. Saat
              </a>
            </li>
          </ul>
        </ng-container>
        <!-- TEK SEFER -->
        <ng-container *ngIf="facade.state.getState().attendance.yoklamaPeriyodu=='teksefer' ">
          <ul class="nav nav-tabs mb-2">
            <li class="nav-item with-100">
              <a class="nav-link active disabled">
                Tek Seferlik Yoklama
              </a>
            </li>
          </ul>
        </ng-container>
        <div class="list-scroll">
          <div *ngFor="let student of facade.getFilteredStudents()" class="student-item">

            <div class="d-flex justify-content-between align-items-center student-row">

              <div>
                <div class="fw-bold">
                  {{ maskName(student.adSoyad) }}
                </div>

                <div class="small text-muted">
                  {{ student.studentId }}
                </div>
              </div>

              <!-- 🔥 SLOT İNDİCATORLAR -->
              <div class="slot-indicators me-2">

                <ng-container *ngFor="let a of student.attendance">

                  <span class="badge slot-dot" [ngClass]="{'active-slot': a.active}">

                    <ng-container *ngIf="a.katildiMi; else notJoined">

                      <!-- Konum dışı -->
                      <i *ngIf="a.konumDisi" class="fa-solid fa-location-crosshairs text-danger joined"
                        title="Konum dışı katılım">
                      </i>

                      <!-- Normal katılım -->
                      <i *ngIf="!a.konumDisi" class="fa-solid fa-check-circle text-success joined" title="Katıldı">
                      </i>

                    </ng-container>

                    <ng-template #notJoined>
                      <i class="fa-solid fa-xmark-circle not-joined-icon" title="Katılmadı"></i>
                    </ng-template>

                  </span>

                </ng-container>

              </div>

              <!-- 🔥 İŞLEMLER -->
              <div class="d-flex gap-2">
                <button mat-button [matMenuTriggerFor]="islemlerMenu" class="btn btn-sm btn-light">
                  İşlemler
                </button>

                <mat-menu #islemlerMenu="matMenu">

                  <button mat-menu-item
                    (click)="facade.updateStudentStatus(student, {  katildiMi: true, konumDisi: false })">
                    ✅ Katıldı
                  </button>

                  <button mat-menu-item
                    (click)="facade.updateStudentStatus(student, {  katildiMi: false, konumDisi: false })">
                    ❌ Katılmadı
                  </button>

                  <button mat-menu-item
                    (click)="facade.updateStudentStatus(student, { katildiMi: true, konumDisi: false })">
                    📍 Konumda
                  </button>

                </mat-menu>
              </div>

            </div>

            <hr />
          </div>
        </div>

    <div class="card p-3 info-card mt-3 summary-card">
  <h5 class="mb-3 d-flex align-items-center gap-2">
    <i class="fa-solid fa-chart-column text-primary"></i>
    Yoklama Özeti
  </h5>

  <ng-container *ngIf="getAttendanceSummary() as summary">

    <!-- Toplam -->
    <div class="summary-total mb-3">
      <span>Toplam Öğrenci</span>
      <strong>{{ summary.toplamOgrenci }}</strong>
    </div>

    <!-- Saatler -->
    <div *ngFor="let s of summary.saatler" class="summary-row">

      <div class="d-flex justify-content-between align-items-center mb-1">
        <span class="fw-semibold">{{ s.saat }}</span>

        <span class="summary-badge">
          ✔ {{ s.katilan }} / ✖ {{ s.katilmayan }}
        </span>
      </div>

      <div class="progress custom-progress">
        <div class="progress-bar"
             [style.width.%]="(s.katilan / summary.toplamOgrenci) * 100">
        </div>
      </div>

    </div>

  </ng-container>
</div>
        <button class="btn btn-outline-success d-flex align-items-center gap-2" (click)="exportToExcel()">
          <i class="fa-solid fa-file-excel"></i>
          Excel’e Aktar
        </button>
      </div>
    </div>
  </div>

  <!-- MODAL -->
  <div class="modal fade" *ngIf="s.ui.modalOpen" [ngClass]="{ 'show d-block': s.ui.modalOpen }" tabindex="-1"
    role="dialog" aria-modal="true">
    <div class="modal-dialog modal-fullscreen d-flex justify-content-center align-items-center">
      <div class="qr-modal-content">
        <!-- HEADER -->
        <div class="modal-header-custom d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-3">
            <img src="https://ankara.edu.tr/assets/images/logo.png" height="70" />

            <div>
              <h5 class="m-0 fw-bold">Ankara Üniversitesi</h5>
              <small class="opacity-75">Online Yoklama Sistemi</small>
            </div>
          </div>

          <button class="close-btn" (click)="facade.closeModal()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <!-- TIMER -->
        <div class="timer-box">
          <i class="fa-solid fa-hourglass-half"></i>

          <span class="ms-2">
            {{ formatKalanSure(s.ui.kalanSure) }}
          </span>


        </div>

        <!-- QR SECTION -->
        <div class="qr-section text-center mt-3">
          <!-- QR VARSA -->
          <ng-container *ngIf="s.ui.qrUret && s.ui.qrBase64">
            <img [src]="s.ui.qrBase64" class="qr-img" />
          </ng-container>

          <!-- QR YOKSA -->
          <ng-container *ngIf="!s.ui.qrUret">
            <div class="qr-info-wrapper">
              <div class="qr-info-card">
                <div class="qr-icon">
                  <i class="bi bi-info-circle"></i>
                </div>

                <h5>QR Kod Kullanılmıyor</h5>

                <p>
                  Yoklama şu anda QR kod olmadan alınmaktadır.
                  <br />
                  <strong>“Buradayım”</strong> butonuna basabilirsiniz.
                </p>

                <button class="btn btn-info btn-sm mt-2">Buradayım</button>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- DERS BİLGİLERİ -->
        <div class="ders-info mt-3">
          <div>
            Aktif Ders Saati:
            <strong>{{ (s.attendance?.aktifSlotIndex ?? 0) + 1 }}</strong>
          </div>

          <div>
            Ders Saati:
            {{ s.course?.dersBaslangic | date: "HH:mm" }} -
            {{ s.course?.dersBitis | date: "HH:mm" }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- OVERLAY -->
  <div class="overlay" *ngIf="s.ui.loading">
    <div class="loader">Yükleniyor...</div>
  </div>
</div>
